import React, { memo, useCallback } from "react";
import _ from "lodash";
import { disabledFields, isOpenBy } from "./Constant";
import {
  spermsOptions,
  spermsPrepMethodOptions,
  spermsQualityOptions
} from "utils/FieldValues";
import { useDispatch, useSelector } from "react-redux";
import { Input, Select, Tooltip } from "antd";
import {
  getEggsToSpermByPatientList,
  getPatientList,
  setPartnerDetailsEDS
} from "redux/reducers/EmbryologyData/embryologyData.slice";

const EmbryologyPartnerDetails = () => {
  const dispatch = useDispatch();

  const { selectedLocation } = useSelector(({ role }) => role);
  const { selectedPatient } = useSelector(({ common }) => common);
  const { IvfFlowsheetList } = useSelector(({ ivfFlowSheet }) => ivfFlowSheet);
  const {
    // spermBySearch,
    embryologyDetails,
    partnerDetailsEDS,
    spermByDonorSearch,
    eggsToSpermByPatientList,
    spermByPatientList,
    spermByDonorPatientList
  } = useSelector(({ embryologyData }) => embryologyData);

  const disabledField = useCallback(
    (key) => {
      const cycleType = embryologyDetails?.cycle_type || "";

      const shouldDisableByMap = disabledFields[key]?.some((type) =>
        type === "FET+Surrogacy"
          ? cycleType.includes("FET") && cycleType.includes("Surrogacy")
          : cycleType.includes(type)
      );

      if (shouldDisableByMap) return true;

      return false;
    },
    [embryologyDetails?.cycle_type]
  );

  const handleStorePartnerDetails = useCallback(
    (key, value) => {
      dispatch(
        setPartnerDetailsEDS({
          ...partnerDetailsEDS,
          [key]: value || null
        })
      );
    },
    [dispatch, partnerDetailsEDS]
  );

  const handleSearch = useCallback(
    (newValue, selectedLocation) => {
      if (newValue && selectedLocation && selectedPatient?._id) {
        dispatch(
          getPatientList({
            patient_name: newValue,
            start: null,
            limit: null,
            patient_reg_id: selectedPatient?._id
          })
        );
      }
    },
    [dispatch, selectedPatient]
  );

  const handleSpermsBySearch = useCallback(
    (newValue, selectedLocation, selectedPatientId, key_name) => {
      if (newValue && selectedLocation && selectedPatientId) {
        dispatch(
          getEggsToSpermByPatientList({
            patient_name: newValue,
            start: null,
            limit: null,
            patient_reg_id: selectedPatientId,
            key_name
          })
        );
      }
    },
    [dispatch]
  );

  const globalSearchTextChange = useCallback(_.debounce(handleSearch, 800), []);
  const globalSpermsBySearchText = useCallback(
    _.debounce(handleSpermsBySearch, 800),
    []
  );

  return (
    <>
      <div className="form_info_wrapper filled">
        <h3 className="mb-3">Partner Details</h3>
        <ul className="grid_wrapper">
          <li className="w_270 w_xs_50">
            {/* <Form.Item
              label="Sperms"
              // name="sperms"
              className="custom_select"
            > */}
            <div className="custom_select spacing-manage">
              <label>Sperms</label>
              <Select
                showSearch
                name="sperms"
                disabled={disabledField("sperms")}
                allowClear={true}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase())
                }
                placeholder="Select"
                value={partnerDetailsEDS?.sperms}
                onChange={(value) => {
                  const fieldValue = value || null;
                  handleStorePartnerDetails("sperms", fieldValue);
                }}
                options={spermsOptions}
              />
            </div>
            {/* </Form.Item> */}
          </li>
          {isOpenBy.includes(partnerDetailsEDS?.sperms) ? (
            <li className="w_270 w_xs_50">
              <div className="search_top">
                {/* <Form.Item
                  label="Sperms By"
                  // name="sperms_by"
                  className="custom_select search_with_select"
                > */}
                <div className="custom_select search_with_select spacing-manage">
                  <label htmlFor="">Sperms By</label>
                  <Select
                    showSearch
                    allowClear={true}
                    name="sperms_by"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.label
                        ?.toLowerCase()
                        ?.localeCompare(optionB?.label?.toLowerCase())
                    }
                    value={partnerDetailsEDS?.sperms_by}
                    placeholder="Search here"
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    onSearch={(e) => {
                      if (Object.keys(selectedPatient)?.length > 0) {
                        // globalSearchTextChange(e, selectedLocation);
                        globalSpermsBySearchText(
                          e,
                          selectedLocation,
                          selectedPatient?._id,
                          "sperms_by"
                        );
                        // setSearchTrigger("sperms_by");
                      }
                    }}
                    onChange={(value) => {
                      const fieldValue = value || null;
                      handleStorePartnerDetails("sperms_by", fieldValue);
                    }}
                    // onChange={(e) => setSperms_byByDetail(e)}
                    notFoundContent={null}
                    // options={(spermBySearch || []).map((d) => ({
                    //   value: d?._id,
                    //   label: d?.patient_full_name
                    // }))}
                    options={(spermByPatientList || []).map((d) => ({
                      value: d?._id,
                      label: d?.patient_full_name
                    }))}
                    // options={(patientList || []).map((d) => ({
                    //   value: d?._id,
                    //   label: d?.patient_full_name,
                    // }))}
                  />
                  {/* Noted */}
                  {/* {Object.keys(pDetail).length > 0 && (
                    <Button
                      className="clearIcon btn_transparent"
                      onClick={handleClearSearch}
                    >
                      <CloseOutlined />
                    </Button>
                  )} */}
                </div>
                {/* </Form.Item> */}
              </div>
            </li>
          ) : null}
          <li className="w_270 w_xs_50">
            {/* <Form.Item
              label="Sperm quality"
            // name="sperms_quality"
            > */}
            <div className="custom_select spacing-manage">
              <label htmlFor="">Sperm quality</label>
              <Select
                showSearch
                allowClear={true}
                name="sperms_quality"
                disabled={disabledField("sperms_quality")}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // filterSort={(optionA, optionB) =>
                //   optionA.label
                //     .toLowerCase()
                //     .localeCompare(optionB.label.toLowerCase())
                // }
                placeholder="Select"
                mode="multiple"
                maxTagCount="responsive"
                value={partnerDetailsEDS?.sperms_quality}
                onChange={(value) => {
                  const fieldValue = value || null;
                  handleStorePartnerDetails("sperms_quality", fieldValue);
                }}
                options={spermsQualityOptions}
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip
                    title={omittedValues.map(({ label }) => label).join(", ")}
                  >
                    <span>Hover Me</span>
                  </Tooltip>
                )}
              />
            </div>

            {/* </Form.Item> */}
          </li>
          {partnerDetailsEDS?.sperms_quality?.includes("Other") && (
            <li className="w_220 w_xs_100">
              {/* <Form.Item
                label="Sperms Quality Other"
              // name="sperms_quality_other"
              > */}
              <div className="custom_normal_input  spacing-manage">
                <label htmlFor="">Sperms Quality Other</label>
                <Input
                  name="sperms_quality_other"
                  placeholder="Sperms Quality Other"
                  value={partnerDetailsEDS?.sperms_quality_other}
                  onChange={(e) => {
                    const fieldValue = e.target.value || null;
                    handleStorePartnerDetails(
                      "sperms_quality_other",
                      fieldValue
                    );
                  }}
                />
              </div>
              {/* </Form.Item> */}
            </li>
          )}
          <li className="w_270 w_xs_50">
            {/* <Form.Item
              label="Sperm prep. Method"
              // name="sperms_prep_method"
              className="custom_select"
            > */}
            <div className="custom_select spacing-manage">
              <label htmlFor="">Sperm prep. Method</label>
              <Select
                showSearch
                name="sperms_prep_method"
                disabled={disabledField("sperms_prep_method")}
                allowClear={true}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // filterSort={(optionA, optionB) =>
                //   optionA.label
                //     .toLowerCase()
                //     .localeCompare(optionB.label.toLowerCase())
                // }
                placeholder="Select"
                value={partnerDetailsEDS?.sperms_prep_method}
                onChange={(value) => {
                  const fieldValue = value || null;
                  handleStorePartnerDetails("sperms_prep_method", fieldValue);
                }}
                options={spermsPrepMethodOptions}
                mode="multiple"
                maxTagCount="responsive"
                maxTagPlaceholder={(omittedValues) => (
                  <Tooltip
                    title={omittedValues.map(({ label }) => label).join(", ")}
                  >
                    <span>Hover Me</span>
                  </Tooltip>
                )}
              />
            </div>
            {/* </Form.Item> */}
          </li>
          {["Other", "Swim down"].some((method) =>
            partnerDetailsEDS?.sperms_prep_method?.includes(method)
          ) && (
            <li className="w_220 w_xs_100">
              {/* <Form.Item
                  label="Sperms Prep Method Other"
                // name="sperms_prep_method_other"
                > */}
              <div className="custom_normal_input spacing-manage">
                <label htmlFor="">Sperms Prep Method Other</label>
                <Input
                  name="sperms_prep_method_other"
                  placeholder="Sperms Prep Method Other"
                  value={partnerDetailsEDS?.sperms_prep_method_other}
                  onChange={(e) => {
                    const fieldValue = e.target.value || null;
                    handleStorePartnerDetails(
                      "sperms_prep_method_other",
                      fieldValue
                    );
                  }}
                />
              </div>

              {/* </Form.Item> */}
            </li>
          )}

          <li className="w_270 w_xs_100">
            {/* <Form.Item
              label="Frozen sperm vial ID"
            // name="frozen_vial_id"
            > */}
            <div className="custom_normal_input spacing-manage">
              <label htmlFor="">Frozen sperm vial ID</label>
              <Input
                placeholder="ID"
                name="frozen_vial_id"
                disabled={disabledField("frozen_vial_id")}
                value={partnerDetailsEDS?.frozen_vial_id}
                onChange={(e) => {
                  const fieldValue = e.target.value || null;
                  handleStorePartnerDetails("frozen_vial_id", fieldValue);
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        </ul>
      </div>
      {IvfFlowsheetList?.planned_cycle?.includes("ICSI-DS") &&
        IvfFlowsheetList?.planned_cycle?.includes("TESA/PESA") && (
          <div className="form_info_wrapper filled">
            <h3 className="mb-3">Partner Details (Donor)</h3>
            <ul className="grid_wrapper">
              <li className="w_270 w_xs_50">
                {/* <Form.Item
                  label="Sperms"
                // name="sperms_donor"
                > */}
                <div className="custom_select  spacing-manage">
                  <label htmlFor="">Sperms</label>
                  <Select
                    showSearch
                    allowClear={true}
                    name="sperms_donor"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.label
                        .toLowerCase()
                        .localeCompare(optionB.label.toLowerCase())
                    }
                    placeholder="Select"
                    value={partnerDetailsEDS?.sperms_donor}
                    onChange={(value) => {
                      const fieldValue = value || null;
                      handleStorePartnerDetails("sperms_donor", fieldValue);
                    }}
                    options={spermsOptions}
                    disabled={disabledField("sperms_donor")}
                  />
                </div>
                {/* </Form.Item> */}
              </li>
              {isOpenBy.includes(partnerDetailsEDS?.sperms_donor) ? (
                <li className="w_270 w_xs_50">
                  <div className="search_top">
                    {/* <Form.Item
                      label="Sperms By"
                      // name="sperms_by_donor"
                      className="custom_select search_with_select"
                    > */}
                    <div className="custom_select search_with_select  spacing-manage">
                      <label htmlFor="">Sperms By</label>
                      <Select
                        showSearch
                        allowClear={true}
                        name="sperms_by_donor"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.label
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.label
                            ?.toLowerCase()
                            ?.localeCompare(optionB?.label?.toLowerCase())
                        }
                        value={partnerDetailsEDS?.sperms_by_donor}
                        placeholder="Search here"
                        defaultActiveFirstOption={false}
                        suffixIcon={null}
                        onSearch={(e) => {
                          if (Object.keys(selectedPatient)?.length > 0) {
                            // globalSearchTextChange(e, selectedLocation);
                            globalSpermsBySearchText(
                              e,
                              selectedLocation,
                              selectedPatient?._id,
                              "sperms_by_donor"
                            );
                            // setSearchTrigger("sperms_by_donor");
                          }
                        }}
                        // onChange={(e) =>
                        //   handleDonorChange(e, "sperms_by_donor")
                        // }
                        onChange={(e) => {
                          const fieldValue = e || null;
                          handleStorePartnerDetails(
                            "sperms_by_donor",
                            fieldValue
                          );
                        }}
                        notFoundContent={null}
                        // options={(spermByDonorSearch || []).map((d) => ({
                        //   value: d?._id,
                        //   label: d?.patient_full_name
                        // }))}
                        options={(spermByDonorPatientList || []).map((d) => ({
                          value: d?._id,
                          label: d?.patient_full_name
                        }))}
                      />
                    </div>
                    {/* {Object.keys(pDetail).length > 0 && (
                        <Button
                          className="clearIcon btn_transparent"
                          onClick={handleClearSearchDonor}
                        >
                          <CloseOutlined />
                        </Button>
                      )} */}
                    {/* </Form.Item> */}
                  </div>
                </li>
              ) : null}
              <li className="w_270 w_xs_50">
                {/* <Form.Item
                  label="Sperm quality"
                  // name="sperms_quality_donor"
                  className="custom_select"
                > */}
                <div className="custom_select spacing-manage">
                  <label htmlFor="">Sperm quality</label>
                  <Select
                    showSearch
                    allowClear={true}
                    name="sperms_quality_donor"
                    disabled={disabledField("sperms_quality_donor")}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    // filterSort={(optionA, optionB) =>
                    //   optionA.label
                    //     .toLowerCase()
                    //     .localeCompare(optionB.label.toLowerCase())
                    // }
                    placeholder="Select"
                    mode="multiple"
                    maxTagCount="responsive"
                    value={partnerDetailsEDS?.sperms_quality_donor}
                    onChange={(value) => {
                      const fieldValue = value || null;
                      handleStorePartnerDetails(
                        "sperms_quality_donor",
                        fieldValue
                      );
                    }}
                    options={spermsQualityOptions}
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Hover Me</span>
                      </Tooltip>
                    )}
                  />
                </div>
                {/* </Form.Item> */}
              </li>
              {partnerDetailsEDS?.sperms_quality_donor?.includes("Other") && (
                <li className="w_220 w_xs_100">
                  {/* <Form.Item
                    label="Sperms Quality Other"
                  // name="sperms_quality_other_donor"
                  > */}
                  <div className="custom_normal_input spacing-manage">
                    <label htmlFor="">Sperms Quality Other</label>
                    <Input
                      name="sperms_quality_other_donor"
                      placeholder="Sperms Quality Other"
                      value={partnerDetailsEDS?.sperms_quality_other_donor}
                      onChange={(e) => {
                        const fieldValue = e.target.value || null;
                        handleStorePartnerDetails(
                          "sperms_quality_other_donor",
                          fieldValue
                        );
                      }}
                    />
                  </div>
                  {/* </Form.Item> */}
                </li>
              )}
              <li className="w_270 w_xs_50">
                {/* <Form.Item
                  label="Sperm prep. Method"
                  // name="sperms_prep_method_donor"
                  className="custom_select"
                > */}
                <div className="custom_select spacing-manage">
                  <label htmlFor="">Sperm prep. Method</label>
                  <Select
                    showSearch
                    allowClear={true}
                    name="sperms_prep_method_donor"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    // filterSort={(optionA, optionB) =>
                    //   optionA.label
                    //     .toLowerCase()
                    //     .localeCompare(optionB.label.toLowerCase())
                    // }
                    placeholder="Select"
                    value={partnerDetailsEDS?.sperms_prep_method_donor}
                    onChange={(value) => {
                      const fieldValue = value || null;
                      handleStorePartnerDetails(
                        "sperms_prep_method_donor",
                        fieldValue
                      );
                    }}
                    options={spermsPrepMethodOptions}
                    disabled={disabledField("sperms_prep_method_donor")}
                    mode="multiple"
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Hover Me</span>
                      </Tooltip>
                    )}
                  />
                </div>
                {/* </Form.Item> */}
              </li>
              {["Other", "Swim down"].some((method) =>
                partnerDetailsEDS?.sperms_prep_method_donor?.includes(method)
              ) && (
                <li className="w_220 w_xs_100">
                  {/* <Form.Item
                      label="Sperms Prep Method Other"
                    // name="sperms_prep_method_other_donor"
                    > */}
                  <div className="custom_normal_input spacing-manage">
                    <label htmlFor="">Sperms Prep Method Other</label>
                    <Input
                      name="sperms_prep_method_other_donor"
                      placeholder="Sperms Prep Method Other"
                      value={partnerDetailsEDS?.sperms_prep_method_other_donor}
                      onChange={(e) => {
                        const fieldValue = e.target.value || null;
                        handleStorePartnerDetails(
                          "sperms_prep_method_other_donor",
                          fieldValue
                        );
                      }}
                    />
                  </div>
                  {/* </Form.Item> */}
                </li>
              )}

              <li className="w_270 w_xs_100">
                {/* <Form.Item
                  label="Frozen sperm vial ID"
                // name="frozen_vial_id_donor"
                > */}
                <div className="custom_normal_input spacing-manage">
                  <label htmlFor="">Frozen sperm vial ID</label>
                  <Input
                    placeholder="ID"
                    name="frozen_vial_id_donor"
                    disabled={disabledField("frozen_vial_id_donor")}
                    value={partnerDetailsEDS?.frozen_vial_id_donor}
                    onChange={(e) => {
                      const fieldValue = e.target.value || null;
                      handleStorePartnerDetails(
                        "frozen_vial_id_donor",
                        fieldValue
                      );
                    }}
                  />
                </div>
                {/* </Form.Item> */}
              </li>
            </ul>
          </div>
        )}
    </>
  );
};

export default memo(EmbryologyPartnerDetails);
